/**
 * ScopePicker — grade de checkboxes dos 21 escopos LGPD agrupados por área.
 * Reutilizado pelos formulários de adicionar e editar contato autorizado.
 *
 * **Motor Neutro D1** — cada caixa cuja chave **não é exigida por nenhuma ação** ganha a marca
 * «sem efeito». Medido na C1: das 21 chaves ofertadas aqui, **16** não gateiam nada (no grupo
 * «Comum», 6 das 7) — o operador marcava e a tela confirmava sucesso. A marca é
 * **informacional**: nada fica `disabled`, porque negar no cliente seria gate no lugar errado (e
 * o tenant pode ter razão para conceder hoje a chave que a sua config futura vai exigir).
 * Alinhar os vocabulários LIBERA acesso hoje negado ⇒ é decisão de PRODUTO do TL (R-C1-b).
 */

import { SCOPE_GROUPS, scopeLabel } from './authorized-contacts-labels';
import { isScopeInert } from './scope-effectiveness';

/** A claim do tamanho EXATO da prova (C1 §3.3): global e conservadora. */
const INERT_TITLE =
  'Nenhuma ação da plataforma exige esta chave hoje — conceder este escopo não muda o comportamento.';

interface ScopePickerProps {
  selected: string[];
  onToggle: (scope: string) => void;
  idPrefix: string;
}

export function ScopePicker({ selected, onToggle, idPrefix }: ScopePickerProps): JSX.Element {
  return (
    <div className="bac-scopes">
      {SCOPE_GROUPS.map((group) => (
        <fieldset key={group.label} className="bac-scope-group">
          <legend className="bac-scope-group__legend">{group.label}</legend>
          <div className="bac-scope-grid">
            {group.scopes.map((scope) => {
              const id = `${idPrefix}-${scope}`;
              const checked = selected.includes(scope);
              const inert = isScopeInert(scope);
              return (
                <label
                  key={scope}
                  htmlFor={id}
                  title={inert ? INERT_TITLE : undefined}
                  className={`bac-chip${checked ? ' bac-chip--on' : ''}${
                    inert ? ' bac-chip--inert' : ''
                  }`}
                >
                  <input
                    id={id}
                    type="checkbox"
                    className="bac-chip__input"
                    checked={checked}
                    onChange={() => onToggle(scope)}
                  />
                  <span>{scopeLabel(scope)}</span>
                  {inert && <span className="bac-chip__inert">sem efeito</span>}
                </label>
              );
            })}
          </div>
        </fieldset>
      ))}
      <p className="bac-scopes__legend">
        <strong>sem efeito</strong> — nenhuma ação da plataforma exige esta chave hoje; conceder não
        altera o que o contato pode fazer.
      </p>
    </div>
  );
}
